<template>
    <div class="pt-4 md:pt-10 pb-5 md:pb-20">
        <div class="text-16 md:text-20 font-bold text-a-brown-502314 mb-4 pl-4 md:pl-4">{{lbl.detail.relate_reward}}</div>
        <div class="splide" id="campaign-relate-slide">
            <div class="splide__track">
                <ul class="splide__list">
                    <li class="splide__slide"
                        v-for="(campaign, k) in campaignList"
                        :key="k"
                        @click="clickCampaign(campaign)">
                        <CampaignRelateItem :campaign="campaign"></CampaignRelateItem>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
//library
import Splide from '@splidejs/splide'; //https://splidejs.com/
//component
import CampaignRelateItem from './CampaignRelateItem.vue';
//mixin
import LocaleMixin from "@/mixin/LocaleMixin.js";

export default {
    mixins: [LocaleMixin],
    components: {
        CampaignRelateItem,
    },
    props: {
        campaignList: { type: Array, default: null },
    },
    data: function () {
        return {
            slider: null,
        };
    },
    mounted: function () {
        this.setupSlide();
    },
    methods: {
        setupSlide: function () {
            this.slider = new Splide('#campaign-relate-slide', {
                autoWidth: true,
                pagination: false,
                arrows: false,
                gap: 32,
                padding: { left: 0, right: 0 },
                breakpoints: {
                    769: {
                        gap: 16,
                        padding: { left: 16, right: 16 },
                    },
                },
            }).mount();
        },

        clickCampaign: function (campaign) {
            this.$router.push('/reward/' + campaign.id);
        },
    },
}
</script>
<style lang="scss" scoped>
</style>
